import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { SearchEmployeeFilter } from '../pages/user/models/search-emplyee-filter';
import { AddEditEmployeeRequest, EmployeeModel, EmployeeResponseModel } from '../pages/user/models/user-model';
import { SecurityGroup } from '../pages/roles/models/security-group.model';
import { ChemicalDbPermissionModel } from '../pages/roles/models/permission.model';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  public searchEmployeesByMultipleParam(
    filter: SearchEmployeeFilter,
    ignoreLoading = false,
  ): Observable<EmployeeResponseModel> {
    return this.post(`admin/employee/search`, filter, ignoreLoading);
  }

  public getSecurityGroups(
    includeLogRole?: boolean,
    includeDuplicate?: boolean,
    searchTerms?: string,
  ): Observable<SecurityGroup[]> {
    return this.get('admin/role', {
      includeLogRole,
      includeDuplicate,
      searchTerms,
    });
  }

  public getAllDepartments(getForSetup = false): Observable<any[]> {
    return this.get(`admin/departments/${getForSetup}`);
  }

  public getRolesHaveLeaderAndDeputyByEmployeeId(employeeId: string): Observable<SecurityGroup[]> {
    return this.get(`admin/employee/${employeeId}/role`);
  }

  public getEmployee(filter: SearchEmployeeFilter): Observable<EmployeeModel[]> {
    return this.get('admin/employee', filter);
  }

  public checkAdminRole(roleIds: number[]): Observable<boolean> {
    return this.post('admin/users/checkAdminRole', roleIds);
  }

  public createEmployee(data: AddEditEmployeeRequest): Observable<number> {
    return this.post('admin/employee', data);
  }

  public isExistedEditLoginName(loginName: string, userId: number): Observable<boolean> {
    return this.get(`admin/employee/${loginName}/${userId}`);
  }

  public isExistedCreateLoginName(loginName: string): Observable<boolean> {
    return this.get(`admin/employee/${loginName}`);
  }

  public updateEmployee(data: AddEditEmployeeRequest): Observable<number> {
    return this.put('admin/employee', data);
  }

  public getPermisionByRole(roleId: string): Observable<ChemicalDbPermissionModel[]> {
    return this.get(`admin/role/permissions/${roleId}`);
  }
}
